import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = JSON.parse(localStorage.getItem('auth_info'));
        if (currentUser && currentUser.auth_key) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.auth_key}`
                }
            });
        }

        return next.handle(request);
    }
}
